import React from 'react'

import { Link, useLocation } from 'react-router-dom'
import UnitBodyOptionsSh from './UnitBodyOptionsSh'
import ButtonsActionsSh from './ButtonsActionsSh'
import { type Unit } from '../../../store/slices/unitsSlice'
import { type ISettings } from '../../../store/slices/userSlice'
import UnitCarouselCard from './UnitCarouselCard'
import useUserType from '../../../hooks/UseUserType'
import { REACT_APP_BSO_SUPPORT_USER_ID, REACT_APP_BSO_USER_ID, USER_ID_KEY } from '../../../urls'
import { setWhereAfterToGo } from '../../../store/slices/modalSlice'
import { useAppSelector } from '../../../hooks/redux'
import { type RootState } from '../../../store/store'

interface IProps {
    unit: Unit
    fromEntry: string | undefined
    settings?: ISettings[]
}


export const getTypeUnitForACtions = (unit: Unit) => {

    const userID = window.localStorage.getItem(USER_ID_KEY) ?? ''

    const task = {
        type: "TYPE UNIT",
        color: "secondary",
    };

    if (unit?.attributes?.User?.data?.id === Number(userID) && (unit?.attributes?.ManagedBy === "Agent" || unit?.attributes?.ManagedBy === "BSO")) {
        task.type = "MY UNIT";
        task.color = "primary";
    }

    if (
        (unit?.attributes?.User?.data?.id !== Number(userID) || Number(REACT_APP_BSO_USER_ID) !== Number(userID)) && unit?.attributes?.ManagedBy === "BSO"
    ) {
        task.type = "BSO UNIT";
        task.color = "warning";
    }

    if (unit?.attributes?.User?.data?.id !== Number(userID) && unit?.attributes?.ManagedBy === "Agent") {
        task.type = "OTHER AGENT UNIT";
        task.color = "info";
    }
    if (unit?.attributes?.User?.data?.id !== Number(userID) && unit?.attributes?.ManagedBy === "Landlord") {
        task.type = "LANDLORD UNIT";
        task.color = "warning";
    }
    return task;
};



export default function UnitBodySh({ unit, fromEntry, settings }: IProps): JSX.Element {
    const { userTypeLowercase, userType } = useUserType()
    const myPublishedUnitsOpen = useAppSelector((state: RootState) => state.units.myPublishedUnitsOpen)

    const isInRequest = unit?.attributes?.Statuses?.includes('Registered')
    const isLandlordPublished = unit?.attributes?.ManagedBy === 'Landlord' && (unit?.attributes?.Statuses ?? []).includes('Landlord Unit')
    const isPublishedForModal = unit?.attributes?.ManagedBy === 'Landlord' ? isLandlordPublished : !isInRequest
    let modalFromEntry = 'catalog';

    modalFromEntry = getTypeUnitForACtions(unit).type === "MY UNIT"
        ? 'my_unit'
        : 'other_agent_s_unit';


    if ((fromEntry === 'myUnitsAgent' || getTypeUnitForACtions(unit).type === "MY UNIT") && userType === 'Agent') {
        modalFromEntry = 'agent_s_unit';
    } else if ((fromEntry === 'other_agent_s_unit' || getTypeUnitForACtions(unit).type === "OTHER AGENT UNIT") && userType === 'Agent') {
        modalFromEntry = 'other_agent_s_unit';
    } else if (fromEntry === 'other_landlord_s_unit' && userType === 'Landlord') {
        modalFromEntry = 'other_landlord_s_unit';
    }

    if (userType === 'Landlord' && myPublishedUnitsOpen && isPublishedForModal) {
        modalFromEntry = 'published_unit_admin'
    }


    return (
        <div className="card-body pb-3 pt-1 px-1 position-relative d-flex flex-column">
            {
                isInRequest &&
                <div className={`d-flex align-items-center justify-content-center opacity-100 position-absolute top-50 w-100`}>
                    <span className={`position-absolute`}>
                        <i className="ki-duotone ki-loading icon-adaptive text-dark">
                            <span className="path1"></span>
                            <span className="path2"></span>
                        </i>
                    </span>
                    < span className={' spinner-border spinner-border-md align-middle p-9 position-relative text-dark'}>
                    </span>
                </div>
            }
            <div className="flex-grow-1 d-flex flex-column">
                <Link
                    to={`/${userTypeLowercase}/modalView/unit_modal/${unit.id}/not/${modalFromEntry}`}
                    className={`text-decoration-none  d-block w-100 ${isInRequest && 'opacity-50'}`}>
                    <UnitCarouselCard unit={unit} />
                    <UnitBodyOptionsSh unit={unit} />
                </Link>
            </div>
            <ButtonsActionsSh unit={unit} fromEntry={fromEntry} settings={settings} />
        </div>
    )
}


